import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "choice-toggle" }
const _hoisted_2 = {
  key: 0,
  class: "ontos-field-label"
}
const _hoisted_3 = {
  key: 1,
  class: "choice-toggle-two-lines"
}
const _hoisted_4 = {
  key: 1,
  class: "choice-toggle-hint text-body-2 text-medium-emphasis"
}
const _hoisted_5 = {
  key: 2,
  class: "choice-toggle-more"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_v_btn_toggle, {
      "model-value": _ctx.modelValue,
      mandatory: "",
      divided: "",
      density: "comfortable",
      variant: "outlined",
      disabled: _ctx.disabled,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
          return (_openBlock(), _createBlock(_component_v_btn, {
            key: String(option.value),
            value: option.value,
            color: option.color,
            class: _normalizeClass({'choice-toggle-conditional': option.conditional})
          }, {
            default: _withCtx(() => [
              (option.icon)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    start: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(option.icon), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              (option.qualifier)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(option.label), 1),
                    _createElementVNode("span", null, _toDisplayString(option.qualifier), 1)
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(option.label), 1)
                  ], 64))
            ]),
            _: 2
          }, 1032, ["value", "color", "class"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["model-value", "disabled"]),
    ((_ctx.disabled && _ctx.disabledReason) || (_ctx.chosen && _ctx.chosen.hint))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.disabled && _ctx.disabledReason)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_v_icon, {
                  size: "small",
                  start: ""
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("mdi-lock", -1)
                  ]))]),
                  _: 1
                }),
                _createTextVNode(_toDisplayString(_ctx.disabledReason), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.chosen!.hint), 1)
              ], 64))
        ]))
      : _createCommentVNode("", true),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
}